<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2 class="hidden-sm-and-down">Buscar Cédulas</h2>
      <div class="flex-grow-1"></div>
      <v-btn class="mx-5" dark small color="blue lighten-1" style="margin-left: -6px;" to="/partes">Ver Partes</v-btn>
      <v-dialog v-model="dialog" max-width="500px" persistent>
        <!-- <template v-slot:activator="{ on }">
          <v-btn dark small  color="grey" style="margin-left: -6px;" v-on="on">Agregar Parte</v-btn>
        </template> -->

        <!--<v-btn slot:activator="{on}" color="grey darken-2" dark class="mb-2">Nuevo</v-btn>-->
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>

          </v-card-title>
          <v-card-text>

            <v-container grid-list-md>
              <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.nombre" label="Nombre(s)" :rules="notBlankRules" :disabled="editedIndex > -1">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.apellido_paterno" label="Primer Apellido" :rules="notBlankRules" :disabled="editedIndex> -1"></v-text-field>
                  </v-flex xs12>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.apellido_materno" label="Segundo Apellido" :disabled="editedIndex > -1">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.num_cedula" label="Cédula" :disabled="editedIndex > -1">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="tiposCedulas"
                      item-text="nombre"
                      item-value="id"
                      label="Tipo Cédula"
                      persistent-hint
                      v-model.trim="editedItem.tipo_cedula"
                      :disabled="editedIndex > -1"
                      :rules="[v => !!v || 'Seleccione una opción']"
                    ></v-select>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.email" label="Email Civil" :rules="emailRules">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.email_penal" label="Email Penal" :rules="emailRules">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="editedItem.celular" label="Celular" :rules="notBlankRules" :disabled="editedIndex > -1">
                    </v-text-field>
                  </v-flex>
                   <v-spacer></v-spacer>
                   <v-flex v-if="mail_repetido" xs12 style="color:#ff5252">
                    Este mail está siendo utilizado por otra parte
                  </v-flex>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" dark @click.native="close">Cancelar</v-btn>
                    <v-btn v-if="editedIndex > -1" color="yellow darken-2" @click.native="addParte(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                    <v-btn v-else color="yellow darken-2" @click.native="addParte(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                  </v-card-actions>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog><!-- end dialog edit o save-->
    </v-card-title>

    <v-form class="mx-10">
      <v-card flat>
        <!-- <v-toolbar color="grey" dark dense flat>
          <h3>Consulta de Partes</h3>
        </v-toolbar> -->
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="nombre"
                label="Nombre(s)"
                prepend-icon="mdi-account"
                clearable
                v-on:keyup.enter="buscarCedula()"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="apellido_paterno"
                label="Primer Apellido"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="apellido_materno"
                label="Segundo Apellido"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
          </v-row>
          <!-- <v-divider vertical></v-divider> -->
          <v-row
            justify="center"
            no-gutters
          >
            <v-col cols="12" md="5">
              <v-text-field
                v-model="num_cedula"
                label="Cédula"
                prepend-icon="mdi-card-text-outline"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-btn block color="primary" @click="clickSearch()" class="my-5">
            Buscar
          </v-btn>
        </v-card-text>
      </v-card>
      <v-divider></v-divider>
      <v-card>
        <div v-if="showAlert">
          <v-alert
            prominent
            outlined
            type="error"
           >
            <v-row align="center">
              <v-col class="grow hidden-xs-only">No se encontraron registros relacionados con la búsqueda.</v-col>
              <v-col class="grow hidden-sm-and-up">No hay registros.</v-col>
              <!-- <v-col class="shrink" >
                <v-btn dark small  color="teal" style="margin-left: -6px;"  @click="agregarParte(item)">Agregar Parte</v-btn>
              </v-col> -->
            </v-row>
          </v-alert>
        </div>
          <template>
            <v-card-title  style="color:#AF8936">
              <h5>{{ titleTabla }}</h5>
            </v-card-title>
            <v-data-table
              :loading="loadingTable"
              hide-default-footer
              :headers="headers"
              :items="listCedulas"
              item-key="id"
              disable-pagination
            >
              <template v-slot:item.action="{ item }">
                <div class="text-center">
                <v-btn class="mx-2" dark x-small  color="blue lighten-1" style="margin-left: -6px;" @click="editItem(item)">
                  Agregar Parte
                </v-btn>
                <!-- <v-btn class="mx-2" icon color="red" @click="deleteParte(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn class="mx-2" dark x-small  color="grey" style="margin-left: -6px;" @click="verTocas(item)">VER TOCAS
                </v-btn> -->
            </div>
              </template>
              <template v-slot:item.tipo_cedula="{ item }">
                {{ item.tipo_cedula == 1 ?  'Estatal' : 'Federal' }}
              </template>
            </v-data-table>
          </template>
      </v-card>
    </v-form>
    <br>

  </v-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');
  import { VueEditor } from "vue2-editor";
  export default {
    data: () => ({
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      email: '',
      sala: '',
      toca: '',
      num_cedula: '',
      parte:[],
      ncompleto:'',
      showTabla: false,
      showAlert: false,
      dialog: false,
      // dialog2: false,
      // dialog3: false,
      loading:false,
      valid: true,
      titleTabla: 'ÚLTIMOS REGISTROS:',
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Primer Apellido', value: 'apellido_paterno' },
        { text: 'Segundo Apellido', value: 'apellido_materno' },
        { text: 'Cédula', value: 'num_cedula' },
        { text: 'Tipo', value: 'tipo_cedula',sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      loadingTable: false,
      editedIndex: -1,
      editedItem: {
        nombre:'',
        apellido_materno:'',
        apellido_paterno:'',
        num_cedula:'',
        tipo_cedula:'',
        email:'',
        email_penal:'',
        celular: '',
        validada: 1
      },
      defaultItem: {
        nombre:'',
        apellido_materno:'',
        apellido_paterno:'',
        num_cedula:'',
        tipo_cedula:'',
        email:'',
        email_penal:'',
        celular: '',
        validada: 1
      },
      tiposCedulas: [
        { id: 1, nombre: "Estatal" },
        { id: 2, nombre: "Federal" }
      ],
      // notificacion:{
      //   asunto:'',
      //   contenido:'',
      // },
      // DefaultNotificacion:{
      //   asunto:'',
      //   contenido:'',
      // },
      //listNotificaciones:[],
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo válido',
      ],
      mail_repetido: false,
    }),
    computed: {
      ...mapGetters([
        "listCedulas","dataNotFound", "roleUser","token_"
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Parte' : 'Agregar Parte'
      },
    },
    mounted(){
      //this.buscarCedula();
      //this.buscarParte();
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    methods: {
      clickSearch(){
        this.titleTabla = 'RESULTADO DE LA BÚSQUEDA:'
        this.loadingTable = true
        //this.getTokenCedula()
        this.buscarCedula()
      },
      // notificarParte(item){
      //   this.dialog2 = true
      //   this.parte = item
      // },
      // getTokenCedula() {
      //   this.$store.dispatch("GET_TOKEN_C", {
      //     email: 'admin@stjjalisco.gob.mx',
      //     password: 'secret',
      //   })
      //   .then((response) => {
      //     if (response.data) {
      //       var token = response.data.token;
      //       //console.log(token);
      //       this.buscarCedula(token)
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // },
      buscarCedula() {
        this.$store.dispatch("CONSULTAR_CEDULAS", {
          //token: token,
          nombre: this.nombre,
          apellido_paterno: this.apellido_paterno,
          apellido_materno: this.apellido_materno,
          num_cedula: this.num_cedula,
        })
        .then((response) => {
          this.loadingTable = false
          //console.log(response);
          if (response.data.status == 'ok') {
            this.showTabla = true
            this.showAlert = false
          } else {
            this.showAlert = true
            this.showTabla = false
          }
        })
        .catch(err => {
          console.log(err);
          this.showAlert = true
          this.showTabla = false
        });
      },

      editItem (item) {
        this.editedIndex = this.listCedulas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.email_penal = this.editedItem.email,
        this.dialog = true
        // Revisamos si ya hay una parte con ese mail en nuestro sistema.
        this.$store.dispatch("CONSULTAR_PARTES", {
          email: this.editedItem.email,
        })
        .then((response) => {
           console.log(response.data);
          if (response.data.status === 'ok'  && response.data.partes.length>0) {
            this.mail_repetido = true;
          } else {
            this.mail_repetido = false;
            console.log(response.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
      },
      addParte(){
        if (this.$refs.form.validate()) {
          this.loading = true;
          var data = this.editedItem;
          this.$store
            .dispatch("SAVE_PARTES_C", {
              nombre: data.nombre,
              primer_apellido: data.apellido_paterno,
              segundo_apellido: data.apellido_materno,
              num_cedula: data.num_cedula,
              tipo_cedula: data.tipo_cedula,
              email: data.email,
              email_penal:data.email_penal,
              celular: data.celular,
              validada: 1,
              token: this.token_
            })
            .then((response) => {
              //console.log(response.message);
              Swal.fire({
                icon: 'success',
                title: 'Se Guardo Correctamente',
                showConfirmButton: false,
                timer: 1500
              })
              this.close();
              this.loading = false;
              //this.buscarParte();
            })
            .catch(error => {
              let error_msj = error.response.data.message;
              console.log( error.response.data);
              // Obtenemos las keys del error
              if(error.response.data.errors){
                let obj_keys = Object.keys(error.response.data.errors);
                error_msj = error.response.data.errors[obj_keys[0]][0];
              }
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: error_msj,
                  showConfirmButton: false,
                  timer: 5000
                })
              this.loading = false;
              //this.showAlert(this.notification);
            });

        }
      },

      editParte(item){
        if (this.$refs.form.validate()) {
          this.loading = true;
          //console.log("store",item);
          this.$store
            .dispatch("EDIT_PARTE_C",item)
            .then((response) => {
              this.dialog=false;
              Swal.fire({
                icon: 'success',
                title: 'Actualizado Correctamente',
                showConfirmButton: false,
                timer: 1500
              })
              //this.buscarParte();
              //this.roles = response.data;//usar response para datos, se puede usar getters
            })
            .catch(err => {
              console.log(err);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response.data.status,
                showConfirmButton: false,
                timer: 1500
              })
              //this.showAlert(this.notification);
            });
          this.loading = false;
        }
      },
      // deleteParte(item){
      //   confirm('Seguro de eliminar el usuario?') &&
      //   //console.log("store",item.id);
      //   //var data = this.$data;
      //   this.$store
      //     .dispatch("DELETE_PARTE",item.id)
      //     .then((response) => {
      //       Swal.fire({
      //         icon: 'success',
      //         title: 'Se Eliminó Correctamente',
      //         showConfirmButton: false,
      //         timer: 1500
      //       })
      //       this.buscarParte();
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       //this.showAlert(this.notification);
      //     });
      // },
      validate () {
        this.$refs.form.validate()
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.$refs.form.reset()
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.dialog = false
        }, 300)
      },
    }
  };
</script>
